module.exports = __webpack_public_path__ + "59857ea3d42632470aec1a39ef2f4bc2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/down-12.png
// module id = 2486
// module chunks = 0